<div class="list-page__header">
	<div class="list-page__header-actions">
		<h2 class="list-page__title">
			{{ 'CONNECTIONS.TITLES.MAIN' | transloco | apwUcfirst }}
		</h2>
		<p-button (onClick)="openAddMenu($event, addMenu)">
			<span class="material-symbols-outlined me-2">add</span>
			{{ 'CONNECTIONS.BUTTONS.ADD' | transloco | apwUcfirst }}
		</p-button>
		<p-menu #addMenu [popup]="true" appendTo="body" [model]="addMenuItems()" />
	</div>
	<p class="list-page__description">
		{{ 'CONNECTIONS.DESCRIPTIONS.MAIN' | transloco }}
	</p>
</div>

<div class="detail-page__content detail-page__content--routed-tabs">
	<p-tabs [value]="activeTab()">
		<p-tablist>
			<p-tab value="databases" routerLink="databases">
				<span class="material-symbols-outlined">database</span>
				{{ 'CONNECTIONS.TITLES.DATABASES' | transloco | apwUcfirst }}
			</p-tab>
			<p-tab value="apis" routerLink="apis">
				<span class="material-symbols-outlined">api</span>
				{{ 'CONNECTIONS.TITLES.APIS' | transloco | apwUcfirst }}
			</p-tab>
			<p-tab value="storages" routerLink="storages">
				<span class="material-symbols-outlined">storage</span>
				{{ 'CONNECTIONS.TITLES.STORAGE' | transloco | apwUcfirst }}
			</p-tab>
			<p-tab value="smtps" routerLink="smtps">
				<span class="material-symbols-outlined">mail</span>
				{{ 'CONNECTIONS.TITLES.SMTP' | transloco | apwUcfirst }}
			</p-tab>
			<p-tab value="bpmns" routerLink="bpmns">
				<span class="material-symbols-outlined">schema</span>
				{{ 'CONNECTIONS.TITLES.BPMN' | transloco | apwUcfirst }}
			</p-tab>
		</p-tablist>
	</p-tabs>
	<router-outlet />
</div>
